import { TranslationRepository } from '../data/translation-repository';
import { LanguagesResponse } from '../types/translation-types';

export class GetLanguagesUseCase {
  constructor(private readonly repository: TranslationRepository) {}

  async execute(): Promise<LanguagesResponse> {
    return this.repository.getLanguages();
  }
}
